// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1lJIX","modalForm":"UpgradeEpcsModal_modalForm__w4ClQ","modalFooter":"UpgradeEpcsModal_modalFooter__vTU3W"};